import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'accent' | 'good' | 'warn' | 'bad';

// Solid tones with contrast-checked foregrounds. The previous tinted style put a
// light hue's text on a lighter tint of the same hue (e.g. ochre-on-ochre/20),
// which failed contrast badly at 10px in the light theme.
const TONE_CLASS: Record<Tone, string> = {
  neutral: 'bg-makhe-surface text-makhe-ink',
  accent: 'bg-makhe-primary text-makhe-on',
  good: 'bg-makhe-forest text-makhe-night',
  warn: 'bg-makhe-ochre text-makhe-night',
  bad: 'bg-makhe-plum text-white',
};

export function StatusChip({
  label,
  tone = 'neutral',
  className,
}: {
  label: string;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-widest',
        TONE_CLASS[tone],
        className,
      )}
    >
      {label}
    </span>
  );
}
